import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from 'react';
const Plot = React.lazy(() => import('react-plotly.js'));
export default function Plotly(props) {
    return (_jsx(Suspense, { fallback: _jsx("div", { children: "Loading Plotly" }), children: _jsx(Plot, Object.assign({ config: { responsive: true }, className: "h-full w-full", useResizeHandler: true }, props)) }));
}
//# sourceMappingURL=Plotly.js.map